import { useQuery } from '@tanstack/react-query';
import { actions } from 'api/actions';
import { endpoints } from 'api/endpoints';
import { withRetry } from 'utils/with-retry';
import { useRequestHistory } from './useRequestHistory';

export const useStoreSetup = () => {
  const { runRequest } = useRequestHistory();

  const { isSuccess, isError, refetch } = useQuery({
    queryKey: ['store-setup'],
    queryFn: async () => {
      await Promise.all([
        runRequest('updateSiteName', actions.updateSiteName),
        runRequest('attachSiteTemplate', actions.attachSiteTemplate),
      ]);
      await runRequest('injectSiteNameComponent', actions.injectSiteNameComponent);
      await runRequest('publishSite', () => endpoints.publishSite({}));
      await Promise.all([
        runRequest('makeProductsVisible', () => withRetry(actions.makeProductsVisible, 40, 2 * 1000)),
        runRequest('fetchSiteUrl', () => withRetry(actions.fetchSiteUrl, 10, 2 * 1000)),
      ]);
      return {};
    },
  });

  return { isSuccess, isError, refetch };
};
